function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.464,5.189h-.981a.537.537,0,0,1-.537-.537V2.247a.186.186,0,0,0-.186-.186H9.347a.536.536,0,0,1-.536-.536V.537A.536.536,0,0,1,9.347,0H13.6a.4.4,0,0,1,.4.4V4.652A.536.536,0,0,1,13.464,5.189Z"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.189.536v.981a.538.538,0,0,1-.537.537H2.247a.186.186,0,0,0-.186.186V4.653a.536.536,0,0,1-.537.536H.536A.536.536,0,0,1,0,4.653V.4A.4.4,0,0,1,.4,0H4.652A.537.537,0,0,1,5.189.536Z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M.536,8.811h.981a.537.537,0,0,1,.537.537v2.4a.186.186,0,0,0,.186.186H4.653a.536.536,0,0,1,.536.536v.988A.536.536,0,0,1,4.653,14H.4a.4.4,0,0,1-.4-.4V9.348A.536.536,0,0,1,.536,8.811Z"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.811,13.464v-.981a.538.538,0,0,1,.537-.537h2.4a.186.186,0,0,0,.186-.186V9.347a.536.536,0,0,1,.537-.536h.988A.536.536,0,0,1,14,9.347V13.6a.4.4,0,0,1-.4.4H9.348A.537.537,0,0,1,8.811,13.464Z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _ref, _ref2, _ref3, _ref4);
};
export default __webpack_public_path__ + "static/media/expand.611dc3fb.svg";
export { SvgComponent as ReactComponent };